module.exports = __webpack_public_path__ + "static/img/kabin.5a05762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/kabin.png
// module id = 98K2
// module chunks = 0